import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBBadge,
} from "mdb-react-ui-kit";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export class InterannualComparisonChart extends React.Component {
  formatCurrency(value) {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value ?? 0);
  }

  getVarianceColor(variance) {
    if (variance > 0) return "#d32f2f"; // Red if increased (worse for expenses, better for income)
    return "#00796b"; // Green if decreased
  }

  render() {
    const { interannualComparison = {} } = this.props;
    
    const {
      ingresosActuales = 0,
      ingresosHaceUnAnio = 0,
      ingresosVariance = 0,
      gastosActuales = 0,
      gastosHaceUnAnio = 0,
      gastosVariance = 0,
    } = interannualComparison;

    // Data for chart
    const chartData = [
      {
        name: "Ingresos",
        "Este mes": ingresosActuales,
        "Hace 1 año": ingresosHaceUnAnio,
      },
      {
        name: "Gastos",
        "Este mes": gastosActuales,
        "Hace 1 año": gastosHaceUnAnio,
      },
    ];

    return (
      <MDBCard>
        <MDBCardBody>
          <MDBCardTitle className="dashboard-section-title">
            <MDBIcon fas icon="chart-bar" className="me-2" />
            Comparativa interanual
          </MDBCardTitle>

          <ResponsiveContainer width="100%" height={200}>
            <BarChart
              data={chartData}
              margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => this.formatCurrency(v)} />
              <Legend />
              <Bar dataKey="Este mes" fill="#1266f1" name="Este mes" />
              <Bar dataKey="Hace 1 año" fill="#cfe9f3" name="Hace 1 año" />
            </BarChart>
          </ResponsiveContainer>

          {/* Variance summary */}
          <MDBRow className="mt-4 g-3">
            <MDBCol md="6">
              <div className="text-center p-2 border-start border-5" style={{ borderColor: "#00796b" }}>
                <p className="text-muted small mb-1">Variancia de ingresos</p>
                <div className="d-flex justify-content-center align-items-center">
                  <MDBIcon
                    fas
                    icon={ingresosVariance > 0 ? "arrow-up" : ingresosVariance < 0 ? "arrow-down" : "minus"}
                    className="me-2"
                    style={{ color: ingresosVariance > 0 ? "#00796b" : "#c62828" }}
                  />
                  <span style={{ fontWeight: "bold", fontSize: "1.1rem", color: ingresosVariance > 0 ? "#00796b" : "#c62828" }}>
                    {ingresosVariance > 0 ? "+" : ""}{ingresosVariance.toFixed(1)}%
                  </span>
                </div>
              </div>
            </MDBCol>
            <MDBCol md="6">
              <div className="text-center p-2 border-start border-5" style={{ borderColor: "#c62828" }}>
                <p className="text-muted small mb-1">Variancia de gastos</p>
                <div className="d-flex justify-content-center align-items-center">
                  <MDBIcon
                    fas
                    icon={gastosVariance > 0 ? "arrow-up" : gastosVariance < 0 ? "arrow-down" : "minus"}
                    className="me-2"
                    style={{ color: gastosVariance < 0 ? "#00796b" : "#c62828" }}
                  />
                  <span style={{ fontWeight: "bold", fontSize: "1.1rem", color: gastosVariance < 0 ? "#00796b" : "#c62828" }}>
                    {gastosVariance > 0 ? "+" : ""}{gastosVariance.toFixed(1)}%
                  </span>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCardBody>
      </MDBCard>
    );
  }
}
